<footer class="footer" >
    <div class="container-fluid">

      <div class="row">
        <div class="col-md-6">
          <div class="footerleft" style="display: flex;">
           <a routerLink="/dashboard"> <img src="/assets/image/logo.jpg"  id="nav-logo" alt=""></a>
           <div style="margin-top: 11px;">
            <span class="vPosition" style="margin-left: 3px;">{{currentApplicationVersion}}</span>
          </div>
          </div>
        </div>
        <div class="col-md-6">
            <ul class="d-flex justify-content-end footerList">
              <li> <a href="https://www.plusphysio.com/contact" target="_blank">Copyright</a> </li>
              <li class="list"><a></a>© {{today | date:'yyyy'}}&nbsp;</li>
              <li> <a href="https://www.ifourtechnolab.com/" target="_blank">ifourtechnolab.com</a> </li>
            </ul>
        </div>
      </div>
    </div>
</footer>



